import { NavigationProp, useLinkTo, useNavigation } from '@react-navigation/native';
import { RootStackParamList } from 'navigation/AppNavigator';
import { ImageBackground, StyleSheet, View } from 'react-native';
import { Image } from 'react-native';
import { calcSizeForTv } from 'utils/index';
import { Platform } from 'utils/platform';

import BackgroundImage from 'assets/background.png';
import Logo from 'assets/loginLogo2x.png';

import Button from 'components/Button';

type TvHelpScreenLayoutProps = {
  children?: React.ReactNode;
};

const TvHelpScreenLayout: React.FC<TvHelpScreenLayoutProps> = ({ children }) => {
  const linkTo = useLinkTo();
  const navigation = useNavigation<NavigationProp<RootStackParamList>>();

  const onBackButtonPress = () => {
    if (Platform.isWebTV) {
      if (document.referrer.includes(window.location.host)) window.history.back();
      linkTo('/');
    }

    if (navigation.canGoBack()) navigation.goBack();
    navigation.navigate('Home');
  };

  return (
    <ImageBackground
      source={BackgroundImage}
      accessibilityLabel="Imagem de fundo com conteúdos do bandplay em tons azul escuro"
      style={styles.backgroundImage}>
      <View style={styles.container}>
        <View style={styles.headerRow}>
          <Button
            useTVFocus
            hasTVPreferredFocus
            variant="back"
            iconType="ChevronLeft"
            backgroundColor="transparent"
            style={styles.backButton}
            onPress={onBackButtonPress}
          />
          <Image source={Logo} accessibilityLabel="Logo do B do Bandplay" style={styles.logo} />
        </View>
        <View style={styles.contentContainer}>{children}</View>
      </View>
    </ImageBackground>
  );
};

const styles = StyleSheet.create({
  backgroundImage: {
    height: '100%',
    backgroundColor: 'rgba(22, 18, 51, 0.8)',
  },
  container: {
    marginTop: calcSizeForTv(120),
    marginLeft: calcSizeForTv(70),
    marginRight: calcSizeForTv(200),
  },
  headerRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  backButton: {
    marginRight: calcSizeForTv(30),
    justifyContent: 'center',
  },
  logo: {
    width: calcSizeForTv(290),
    height: calcSizeForTv(82),
  },
  contentContainer: {
    marginTop: calcSizeForTv(130),
  },
});

export default TvHelpScreenLayout;
